import React, { useEffect, useState } from "react";
import { Input, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import UseApi from "../../../Reusable/CallApi/UseApi";

const PageWrapper = styled.div`
  text-align: left;
`;

const Title = styled.p`
  font-size: 20px;
  font-weight: 500;
  color: #1f243b;
  margin-bottom: 16px;
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const TotalCount = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: #1f243b;
`;

const SearchInput = styled(Input)`
  color: #636980;
  border: 1px solid #e2e2e8;
  width: 210px;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 400;
`;

const StyledTable = styled(Table)`
  border: 1px solid #e2e2e8;
  border-radius: 8px;
  cursor: pointer;

  .ant-table-thead > tr > th {
    font-size: 16px;
    font-weight: 500;
    color: #1f243b;
  }

  .ant-table-tbody > tr > td {
    font-size: 14px;
    font-weight: 400;
    color: #636980;
  }

  .table-row-white {
    background-color: #ffffff;
  }

  .table-row-gray {
    background-color: #f5f5f5;
  }
`;

const columns = [
  { title: "Task Name", dataIndex: "taskName", key: "taskName" },
  { title: "Course", dataIndex: "courseName", key: "courseName" },
  { title: "Task Type", dataIndex: "taskType", key: "taskType" },
  { title: "People Enrolled", dataIndex: "peopleEnrolled", key: "peopleEnrolled" },
  { title: "Completed", dataIndex: "peopleCompleted", key: "peopleCompleted" },
  { title: "In Progress", dataIndex: "peopleInProgress", key: "peopleInProgress" },
  { title: "Not Passed", dataIndex: "peopleNotPassed", key: "peopleNotPassed" },
];

function Coursetask() {
  const navigate = useNavigate();
  const clientId = useSelector((state) => state.authTracking.userInfo.clientId);
  const { data, loading, request } = UseApi();
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (!clientId) return;
    // UseApi's request() rethrows on failure - uncaught here, this was a
    // genuine unhandled promise rejection (CRA's dev error overlay
    // whenever this endpoint fails).
    request({ endPoint: `/report/gettaskreport/${clientId}`, method: "get" }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId]);

  const tasks = (data?.response || []).map((item, index) => ({
    key: item.taskId ?? index,
    ...item,
  }));

  const filteredTasks = tasks.filter((task) =>
    Object.values(task).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <PageWrapper>
      <Title>Course Task Report</Title>
      <HeaderRow>
        <TotalCount>Total Course Task: {filteredTasks.length}</TotalCount>
        <SearchInput
          placeholder="Search"
          prefix={<SearchOutlined style={{ color: "#636980" }} />}
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
        />
      </HeaderRow>
      <StyledTable
        columns={columns}
        dataSource={filteredTasks}
        loading={loading}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-white" : "table-row-gray"
        }
        pagination={false}
        onRow={(record) => ({
          onClick: () => {
            navigate(`/designtask/${record.taskId}`, { state: { task: record } });
          },
        })}
      />
    </PageWrapper>
  );
}

export default Coursetask;
